import DraftGraphic from "../../../../src/data/articles/cube-in-the-time-of-covid-with-rotisserie-draft/DraftGraphic.tsx";
import SheetTemplateLinks from "../../../../src/data/format-guide/rotisserie-draft/SheetTemplateLinks.tsx";
import * as React from 'react';
export default {
  DraftGraphic,
  SheetTemplateLinks,
  React
};